import { render, staticRenderFns } from "./DonorsProfile.vue?vue&type=template&id=5a24e806&scoped=true"
import script from "./DonorsProfile.vue?vue&type=script&lang=js"
export * from "./DonorsProfile.vue?vue&type=script&lang=js"
import style0 from "./DonorsProfile.vue?vue&type=style&index=0&id=5a24e806&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a24e806",
  null
  
)

export default component.exports